import Colors from './colors'

const toothbrushes = [
  {
    title: 'rising<br>star',
    imgUrl: '/static/img/be-you-prichute-01.png',
    color: Colors.yellow,
    name: 'rising star',
    key: 'yellow',
    playlist: 'https://open.spotify.com/user/spotify/playlist/37i9dQZF1DXcRXFNfZr7Tp?si=BcaYLxAMScmno_iaudxJfA',
    pasteUrl: 'https://shop.curaprox.sk/produkty/244-zubna-pasta-be-you-rising-star.html'
  },
  {
    title: 'pure<br>happiness',
    imgUrl: '/static/img/be-you-prichute-04.png',
    color: Colors.orange,
    name: 'pure happiness',
    key: 'orange',
    playlist: 'https://open.spotify.com/user/spotify/playlist/37i9dQZF1DX7KNKjOK0o75?si=ZwP1F5tSTR65-gREpbSHgw',
    pasteUrl: 'https://shop.curaprox.sk/produkty/241-zubna-pasta-be-you-pure-happiness.html'
  },
  {
    title: 'explorer',
    imgUrl: '/static/img/be-you-prichute-03.png',
    color: Colors.green,
    name: 'explorer',
    key: 'green',
    playlist: 'https://open.spotify.com/user/spotify/playlist/37i9dQZF1DWSQScAbo5nGF?si=clZVWkGHSxG7EbsyUN1Gbw',
    pasteUrl: 'https://shop.curaprox.sk/produkty/243-zubna-pasta-be-you-explorer.html'
  },
  {
    title: 'challenger',
    imgUrl: '/static/img/be-you-prichute-02.png',
    color: Colors.pink,
    name: 'challenger',
    key: 'pink',
    playlist: 'https://open.spotify.com/user/spotify/playlist/37i9dQZF1DXdxcBWuJkbcy?si=d6U1_CvWTYmdvLeVYc8oTg',
    pasteUrl: 'https://shop.curaprox.sk/produkty/239-zubna-pasta-be-you-challenger.html'
  },
  {
    title: 'daydreamer',
    imgUrl: '/static/img/be-you-prichute-05.png',
    color: Colors['blue-light'],
    name: 'daydreamer',
    key: 'blue-light',
    playlist: 'https://open.spotify.com/user/spotify/playlist/37i9dQZF1DWVV27DiNWxkR?si=ypIu5ZUSTU2xPsYhTatx_g',
    pasteUrl: 'https://shop.curaprox.sk/produkty/240-zubna-pasta-be-you-daydreamer.html'
  },
  {
    title: 'candy lover',
    imgUrl: '/static/img/be-you-prichute-06.png',
    color: Colors['pink-light'],
    name: 'candy lover',
    key: 'pink-light',
    playlist: 'https://open.spotify.com/user/spotify/playlist/37i9dQZF1DWWzhxZzVxMP3?si=fId1te2OSfCMTFjXkBCl9g',
    pasteUrl: 'https://shop.curaprox.sk/produkty/242-zubna-pasta-be-you-candy-lover.html'
  }
]

export default toothbrushes



// WEBPACK FOOTER //
// ./src/components/toothbrushes.js